var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.editor)?_c('div',{staticClass:"html-editor"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"editor"},[_c('MenuBar',{attrs:{"editor":_vm.editor}}),_c('EditorContent',{staticClass:"editor-content",attrs:{"editor":_vm.editor}}),(_vm.disabled)?_c('div',{staticClass:"disabled-wrapper"}):_vm._e()],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }